module.exports = __webpack_public_path__ + "img/ic24Personal.c55fe0d7.svg";